import React from 'react';
import login2FASvg from "img/login-2fa.svg";
import {useTranslation} from "react-i18next";
import LoginModelPage from "v4/pages/front/Login/components/LoginModelPage";
import FormRender from "v4/components/form/FormRender/FormRender";
import LoginField from "v4/pages/front/Login/components/LoginField";
import FormRest from "v4/components/form/FormRender/components/FormRest/FormRest";
import FormSubmitButton from "v4/components/form/FormRender/components/FormSubmitButton/FormSubmitButton";
import useLogin2FA from "v4/pages/front/Login2FA/hooks/useLogin2FA";
import {routesBase} from "v4/data/appRoutes";
import Login2FaRemainingTime from "v4/pages/front/Login2FA/components/Login2FARemainingTime/Login2FARemainingTime";

export default function Login2FAPage() {
    const {t} = useTranslation();

    const {
        form,
        formErrorMessage,
        onSubmit,
        isLoading,
        onGoBackToLogin,
    } = useLogin2FA();

    return (
        <LoginModelPage imageLeftRender={() => <img src={login2FASvg} alt="" width="173" height="150" style={{padding: '3rem'}}/>}
                        goBackTo={routesBase.baseLogin} goBackOnClick={onGoBackToLogin}>
            <Login2FaRemainingTime/>
            <FormRender form={form}
                        onSubmit={onSubmit}
                        fieldRender={(field, formRenderMethods) => (
                            <LoginField field={field}
                                        isDisabled={isLoading}
                                        formRenderMethods={formRenderMethods}/>
                        )}
            >
                <FormRest/>
                {formErrorMessage && <p className="login__form__error">{formErrorMessage}</p>}

                <div className="d-flex align-items-center">
                    <FormSubmitButton isLoading={isLoading} additionalClassName="login__form__btn">
                        {t('login')}
                    </FormSubmitButton>
                </div>
            </FormRender>
        </LoginModelPage>
    )
}
